import { module } from "angular";
import { SitesListWidgetComponent } from "./SitesListWidgetComponent";

module("mmGui").component("mmSitesListWidget", new SitesListWidgetComponent());
